import { useNavigate } from 'react-router-dom'

import { getAdminSession, clearAdminSession, saveAdminSession } from '../config/adminSession'
import { useApiEnvironment } from '../config/apiEnvironment'

export default function AuthUser() {
  const navigate = useNavigate()
  const { environment } = useApiEnvironment()
  const session = getAdminSession(environment)

  const saveToken = (user, token) => {
    saveAdminSession({ user, token }, environment)
    navigate('/users/list')
  }

  const logout = () => {
    clearAdminSession(environment)
    navigate('/login')
  }

  return {
    setToken: saveToken,
    token: session?.token || null,
    user: session?.user || null,
    getToken: () => getAdminSession(environment)?.token || null,
    logout,
  }
}
